import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HeartFilled, SafetyCertificateFilled } from "@ant-design/icons";
import { Button, theme } from "antd";
import { ESubscriptionCancellationReason } from "@devowl-wp/api-real-commerce";
import { trackAnalyticsEvent } from "../../../../others/tracking.js";
import { __ } from "../../../../utils/i18n.js";
import { InfoCard } from "../infoCard.js";
const CancellationReasonContextualBanner = ({ selectedReason, isRcb })=>{
    const { token } = theme.useToken();
    let banner = null;
    if (selectedReason === ESubscriptionCancellationReason.ProductIssue) {
        banner = {
            icon: /*#__PURE__*/ _jsx(HeartFilled, {
                style: {
                    color: token.colorPrimary,
                    fontSize: 18
                }
            }),
            heading: __("Don't leave with the problem unsolved"),
            body: __("We know how frustrating it is when something doesn't work. Give us one chance to fix it for you! A real person on our team will work on it with you."),
            ctaLabel: __("Open a support ticket"),
            ctaHref: __("https://devowl.io/support/")
        };
    } else if (selectedReason === ESubscriptionCancellationReason.BetterAlternativeFound) {
        banner = {
            icon: /*#__PURE__*/ _jsx(HeartFilled, {
                style: {
                    color: token.colorPrimary,
                    fontSize: 18
                }
            }),
            heading: __("What are we missing for you?"),
            body: __("If another product fits your needs better, we'd love to know why. A real person reads every message, and your feedback shapes what we build next."),
            ctaLabel: __("Talk to our team"),
            ctaHref: __("https://devowl.io/support/")
        };
    } else if (selectedReason === ESubscriptionCancellationReason.TooExpensive && isRcb) {
        banner = {
            icon: /*#__PURE__*/ _jsx(SafetyCertificateFilled, {
                style: {
                    color: token.colorPrimary,
                    fontSize: 18
                }
            }),
            heading: __("Cheaper at first glance often costs more later"),
            body: __("Real Cookie Banner is built by lawyers and tech experts so legally compliant consent stays simple for you. Cheaper alternatives often skip the legal piece, so savings vanish in legal research or a lawyer's bill to make it compliant."),
            ctaLabel: __("Compare Real Cookie Banner with alternatives"),
            ctaHref: __("https://devowl.io/wordpress-real-cookie-banner/compare/")
        };
    }
    if (!banner) {
        return null;
    }
    const handleCtaClick = ()=>{
        trackAnalyticsEvent("cancellation_support_cta_clicked", {
            ga: {
                event_category: "account",
                event_label: "Cancellation support CTA clicked",
                value: selectedReason
            },
            matomo: {
                category: "account",
                name: "Cancellation support CTA clicked",
                value: selectedReason
            }
        });
    };
    return /*#__PURE__*/ _jsx("div", {
        className: "rc-account-v2-cancellation-reason-banner",
        children: /*#__PURE__*/ _jsxs(InfoCard, {
            variant: "primary-soft",
            icon: banner.icon,
            heading: banner.heading,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "rc-account-v2-cancellation-reason-banner__body",
                    children: banner.body
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "rc-account-v2-cancellation-reason-banner__cta",
                    children: /*#__PURE__*/ _jsx(Button, {
                        type: "primary",
                        href: banner.ctaHref,
                        target: "_blank",
                        rel: "noreferrer",
                        onClick: handleCtaClick,
                        children: banner.ctaLabel
                    })
                })
            ]
        })
    });
};
export { CancellationReasonContextualBanner };
